
import catchify from 'catchify';
import { SMART_COLLECTIONS_URL } from '@/constants/api';
import SmartCollection from './SmartCollection';

export default {
  components: {
    SmartCollection,
  },
  props: {
    collectionSlug: {
      type: String,
      required: true,
    },
    templateSlug: {
      type: String,
      required: false,
      default: '',
    },
    /* jw: controls whether the carousel's width will be based on its container or the viewport */
    relativeToContainer: {
      type: Boolean,
      default: false,
    },
  },
  async fetch() {
    const [error, response] = await catchify(
      this.$cachios.get(`${SMART_COLLECTIONS_URL}/${this.collectionSlug}/?format=json&template_slug=${this.templateSlug}`),
    );

    if (error) {
      // log to gray log on server, no log on client - the entire section wont show
      if (process.server) {
        console.log(`Error retrieving embedded smart collection ${this.collectionSlug} (${this.templateSlug || 'N/A'}):`, error); // eslint-disable-line no-console
      }
    } else {
      const { data: { smart_collection: collection } = {} } = response || {};
      this.collection = collection;
    }
  },
  data() {
    return {
      collection: null,
    };
  },
};
